import angular from "angular";
import LogInPageComponent from "./log-in-page/log-in-page";
import SignUpPageComponent from "./sign-up-page/sign-up-page";
import ResetPasswordPageComponent from "./reset-password-page/reset-password-page";
import AccessFromMobile from "./access-from-mobile/access-from-mobile";

const AuthModule = angular
  .module("modules.auth", [])
  .component("logInPage", LogInPageComponent)
  .component("signUpPage", SignUpPageComponent)
  .component("resetPasswordPage", ResetPasswordPageComponent)
  .component("accessFromMobile", AccessFromMobile);

export default AuthModule;
